import React, { forwardRef } from 'react';
import { Input } from '@chakra-ui/react';

const PhoneInput = forwardRef(({ value, onChange, onBlur, ...props }:any, ref) => {

  const handleChange = (e: any) => {
    const value = e.target.value.replace(/\D/g, '');
    e.target.value = value
    onChange(value)
  }

  return <>
    <Input
      ref={ref}
      type="text" // Use text type to avoid issues with 'e' in type="number"
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      maxLength={10}
      {...props}
    />

  </>
})

export default PhoneInput
